<script setup>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { fetchAppVersion, updateAppVersion } from "./api";

const route = useRoute(), router = useRouter();
const id = route.params.id;
const loading = ref(false), saving = ref(false), success = ref(false), error = ref(""), validationError = ref(""), notFound = ref(false);
const form = ref({ min_ios_version: "", current_ios_version: "", min_android_version: "", current_android_version: "" });

onMounted(async () => {
  loading.value = true;
  try {
    const v = await fetchAppVersion(id);
    if (!v) { notFound.value = true; return; }
    form.value = { min_ios_version: v.min_ios_version ?? "", current_ios_version: v.current_ios_version ?? "", min_android_version: v.min_android_version ?? "", current_android_version: v.current_android_version ?? "" };
  } catch { error.value = "Couldn't load app version."; }
  finally { loading.value = false; }
});

async function save() {
  success.value = false; error.value = ""; validationError.value = "";
  const f = form.value;
  if (!f.min_ios_version.trim() || !f.current_ios_version.trim() || !f.min_android_version.trim() || !f.current_android_version.trim()) { validationError.value = "All fields are required."; return; }
  saving.value = true;
  try { await updateAppVersion(id, { ...f }); success.value = true; setTimeout(() => router.push({ name: "app-versions" }), 800); }
  catch { error.value = "Error occurred. Please try again."; }
  finally { saving.value = false; }
}
</script>

<template>
  <section>
    <VBtn variant="text" prepend-icon="mdi:arrow-left" class="mb-4" @click="router.push({ name: 'app-versions' })">Back</VBtn>
    <h1 class="text-h5 mb-4">Edit App Version</h1>
    <p v-if="loading">Loading…</p>
    <VAlert v-else-if="notFound" type="error">App version not found.</VAlert>
    <VCard v-else class="pa-4" max-width="560">
      <VAlert v-if="error" type="error" class="mb-4">{{ error }}</VAlert>
      <VAlert v-if="success" type="success" class="mb-4">Updated successfully.</VAlert>
      <form @submit.prevent="save">
        <VRow>
          <VCol cols="12" md="6"><VTextField v-model="form.min_ios_version" label="Min iOS Version" /></VCol>
          <VCol cols="12" md="6"><VTextField v-model="form.current_ios_version" label="Current iOS Version" /></VCol>
          <VCol cols="12" md="6"><VTextField v-model="form.min_android_version" label="Min Android Version" /></VCol>
          <VCol cols="12" md="6"><VTextField v-model="form.current_android_version" label="Current Android Version" /></VCol>
        </VRow>
        <VAlert v-if="validationError" type="warning" class="mb-4">{{ validationError }}</VAlert>
        <VBtn type="submit" :loading="saving" class="mt-2">Save</VBtn>
      </form>
    </VCard>
  </section>
</template>
